@if (returnNote$ | async; as returnNote) {
  @if (deliveryNote$ | async; as deliveryNote) {
    <div class="mb-5 mt-3 flex flex-col">
      <div>
        <h4 class="text-2xl font-semibold">Retourschein<br>{{ deliveryNote.adresseBean?.kurzbez }}</h4>
      </div>
      <div class="color-light text-sm font-medium mt-1">
        {{ (deliveryNote?.type?.type === 'AUSLIEFERUNG' ? "#DELIVERY_NOTE.DETAILS.DELIVERY_NOTE" : "#DELIVERY_NOTE.DETAILS.MATERIAL_NOTE") | translate }} {{ deliveryNote.belegnummer }}
      </div>
    </div>
    <div class="mb-5">
      <div class="flex flex-row justify-between items-center flex-nowrap">
        <span class="soft-overline">{{ deliveryNote?.type?.bezeichnung }}</span>
      </div>
      <!-- the trackBy is necessary to keep the input selection -->
      @for (bewelf of deliveryNote.bewelfs | filter:filterBewelfs; track trackBewelfs($index, bewelf); let last = $last) {
        <div class="separator-top"
          [class.separator-bottom]="last"
          >
          <lib-return-note-storno-bewe-item
            [addedFromSearch]="false"
            [bewelf]="bewelf"
            [returnNoteId]="returnNote.id"
            [value]="returnNote.bewes|single:filterSingleStornoBewe:bewelf">
          </lib-return-note-storno-bewe-item>
        </div>
      }
    </div>
    @if ($any(returnNote.bewes) | filter:filterEmballageBewe; as emballagenBewes) {
      @if ((emballagenBewes?.length ?? 0) > 0) {
        <div class="mb-5">
          <div class="soft-overline mb-2">{{ '#DELIVERY_NOTE.RETOUR.EMBALLAGEN' | translate }}</div>
          @for (bewe of emballagenBewes; track bewe; let last = $last) {
            <div class="separator-top" [class.separator-bottom]="last">
              <lib-return-note-emballage-bewe-item
                [value]="$any(bewe)"
                [returnNoteId]="returnNote.id">
              </lib-return-note-emballage-bewe-item>
            </div>
          }
        </div>
      }
    }
    @if (returnNote.bewes | filter:filterVermerkBewe; as vermerkBewes) {
      @if ((vermerkBewes?.length ?? 0) > 0) {
        <div class="mb-5">
          <div class="soft-overline mb-2">{{ '#DELIVERY_NOTE.RETOUR.VERMERKITEMS' | translate }}</div>
          @for (bewe of vermerkBewes; track bewe; let last = $last) {
            <div class="separator-top border-box" [class.separator-bottom]="last">
              <div class="flex flex-row justify-between items-center border-box p-3">
                <span>
                  {{ bewe.vermerk }}
                  @if (bewe?.files?.length) {
                    <i class="fa-regular fa-images info-icon"></i>
                  }
                </span>
                <div class="flex">
                  <span class="cursor-pointer" (click)="onAddVermerkImage(returnNote.id, bewe)">
                    <i class="fa-regular fa-ellipsis-vertical"></i>
                  </span>
                  <span style="width: 52px; " class="flex items-center justify-end">
                    <i class="fa-regular fa-trash pointer p-1" style="color: var(--colorError)" (click)="removeBewe(returnNote.id, bewe)"></i>
                  </span>
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
    @if (searchStornoBewes$ | async; as searchBewes) {
      @if ((searchBewes?.length ?? 0) > 0) {
        <div class="mb-5">
          <div class="soft-overline mb-2">{{ '#DELIVERY_NOTE.RETOUR.SEARCH' | translate }}</div>
          @for (bewe of searchBewes; track $any(trackSearchBewelfs)($index, bewe); let last = $last) {
            <div class="separator-top"
              [class.separator-bottom]="last"
              >
              <lib-return-note-storno-bewe-item
                [addedFromSearch]="true"
                [bewelf]="bewe.bewelf"
                [returnNoteId]="returnNote?.id ?? ''"
                [value]="returnNote.bewes|single:filterSingleSearchStornoBewe:bewe.bewelf">
              </lib-return-note-storno-bewe-item>
            </div>
          }
        </div>
      }
    }
    @if (scanItems$ | async; as scanItems) {
      @if ((scanItems?.length ?? 0) > 0) {
        <div class="mb-5">
          <div class="soft-overline mb-2">{{ '#DELIVERY_NOTE.RETOUR.SCAN' | translate }}</div>
          @for (item of scanItems; track trackScanItems($index, item); let last = $last) {
            <div class="separator-top"
              [class.separator-bottom]="last"
              >
              <lib-return-note-scan-item
                [item]="item"
                [returnNoteId]="returnNote?.id ?? ''">
              </lib-return-note-scan-item>
            </div>
          }
        </div>
      }
    }
    <div class="flex flex-row justify-end items-center mt-1" >
      <a href="#" class="soft-link mt-3" (click)="$event.preventDefault(); addBewe(returnNote.id)">
        <i class="fa-regular fa-plus"></i> {{ '#DELIVERY_NOTE.RETOUR.ADD_POSITION_LABEL' | translate }}
      </a>
    </div>
    <div class="mb-5">
      <div class="soft-overline mb-2">
        {{  '#DELIVERY_NOTE.RETOUR.COMMENT' | translate}}
      </div>
      <soft-multiline-input
        [lines]="5"
        [placeholder]="'#DELIVERY_NOTE.RETOUR.ADD_COMMENT' | translate"
        [value]="returnNote.vermerk"
        (valueChange)="patchReturnNote(returnNote.id, {vermerk: $event})">
      </soft-multiline-input>
    </div>
    <div class="flex items-center justify-between w-full border border-gray-200 rounded p-3">
      <p class="text-lg font-medium">Mail an Sachbearbeiter</p>
      <div class="flex">
        <soft-toggle-switch [checked]="returnNote?.email ?? false" (valueChange)="patchReturnNote(returnNote.id, {email: $event})"></soft-toggle-switch>
      </div>
    </div>
    <!--<button class="soft-button primary fixed-button" (click)="save(id, item.bewelfs)">
    <ng-container *ngIf="!(isSaving$ | async); else spinnerTemplate">{{ '#DELIVERY_NOTE.RETOUR.PRIMARY_BUTTON' | translate }}</ng-container>
    <ng-template #spinnerTemplate>
      <soft-loading-spinner class="spin"></soft-loading-spinner>
    </ng-template>
  </button>-->
  <button class="soft-button primary w-full h-14 mt-4" (click)="onSubmit()">Übernehmen</button>
}
}



